import React from 'react';
export function WhoIsForSection() {
  const painPoints = ['Sabes que deberías "cuidarte" pero nadie te ha explicado exactamente QUÉ pasa dentro de tu cuerpo', 'Te dijeron "prediabetes" o "azúcar alta" y esa palabra se quedó dando vueltas sin un plan claro', 'En tu familia hay historial de diabetes y quieres actuar ANTES — no después', 'Alguien que amas enfrenta complicaciones y quieres entender qué le está pasando', 'Has probado dietas y restricciones, pero sin entender el POR QUÉ, nada se sostiene', 'Quieres tomar el control de tu salud metabólica — porque nadie más lo va a hacer por ti'];
  return <section className="py-16 md:py-24 px-4 bg-cream" data-id="element-481">
      <div className="max-w-4xl mx-auto" data-id="element-482">
        <div className="text-center mb-12" data-id="element-483">
          <span className="inline-block text-cta font-bold tracking-widest text-sm uppercase mb-4" data-id="element-484">
            ¿TE IDENTIFICAS?
          </span>
          <h2 className="text-3xl md:text-4xl lg:text-5xl font-serif font-bold text-navy leading-tight text-balance" data-id="element-485">
            Si algo de esto te suena familiar, este libro fue escrito para ti.
          </h2>
        </div>

        <div className="flex justify-center mb-10" data-id="element-486">
          <img src="https://cdn.magicpatterns.com/uploads/8BUv76atM2yFRi2yFnzECy/Imagen_-_Si_algo_de_esto_te_suena_familiar.png" alt="Mujer leyendo etiqueta nutricional en el supermercado" className="w-full max-w-md h-auto rounded-2xl shadow-lg object-cover" data-id="element-487" />
        </div>

        <div className="bg-white rounded-2xl shadow-sm border border-navy/5 p-6 md:p-10 mb-12" data-id="element-488">
          <ul className="space-y-6" data-id="element-489">
            {painPoints.map((point, idx) => <li key={idx} className="flex items-start gap-4" data-id="element-490">
                <span className="text-cta font-bold text-xl mt-0.5 shrink-0" data-id="element-491">
                  →
                </span>
                <span className="text-navy/80 font-sans text-lg leading-relaxed" data-id="element-492">
                  {point}
                </span>
              </li>)}
          </ul>
        </div>

        <div className="text-center max-w-3xl mx-auto" data-id="element-493">
          <p className="text-xl md:text-2xl font-serif italic text-cta leading-relaxed" data-id="element-494">
            "Tu salud es una responsabilidad que nadie puede transferir. Pero
            para ejercerla, necesitas información."
          </p>
        </div>
      </div>
    </section>;
}